import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { FormlyFormOptions } from '@ngx-formly/core';
import { ScStepType } from '../../../models';

@Component({
  selector: 'sc-horizontal-stepper',
  templateUrl: './sc-horizontal-stepper.component.html',
  styleUrls: ['./sc-horizontal-stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScHorizontalStepperComponent implements OnInit, OnDestroy {
  @ViewChild(MatHorizontalStepper) public stepper: MatHorizontalStepper;
  @Input() public steps: ScStepType[];
  @Input() public model: any;
  @Input() public doneOn: number;
  public activedStep = 0;

  public form: any;
  public options: FormlyFormOptions[];
  constructor() {}

  public ngOnInit(): void {
    this.form = new FormArray(this.steps.map(() => new FormGroup({})));
    this.options = this.steps.map(step => step.options || {});
  }

  public prevStep(step: number) {
    this.activedStep = step - 1;
    this.stepper.previous();
    window.dispatchEvent(new Event('resize'));
  }

  public nextStep(step: number) {
    this.activedStep = step + 1;
    this.stepper.next();
    window.dispatchEvent(new Event('resize'));
  }

  public submit() {}

  ngOnDestroy() {
    this.form.reset();
    this.model = {};
    this.steps = [];
    this.activedStep = 0;
  }
}
